<template>
    <div
        :id="modalUuid"
        class="flex items-center px-(--spacing-button-y-md)"
    >
        <div
            class="flex items-center cursor-pointer space-x-1"
            :data-mode="dataModeForTheme"
            :style="{
                '--shape-neutral-extra-subtle': version.theme_override_color ?? 'var(--surface-primary)',
                '--shape-neutral-extra-strong': 'var(--text-neutral-base)',
            }"
            @click="openSwitcher"
        >
            <UIAvatar
                :avatar="active?.avatar"
                :size-override="size"
            />
            <DIcon
                icon="heroicons:chevron-down-20-solid"
                size="4"
            />
        </div>
    </div>
</template>

<script setup>
    import { v4 as uuidv4 } from 'uuid'
    import { DIcon } from '@digistorm/spark'
    import { modalController } from '@ionic/vue'

    import UIAvatar from '@/components/ui/UIAvatar.vue'
    import InlineSwitcherModal from '@/components/filters/InlineSwitcherModal.vue'

    const emit = defineEmits(['switch'])

    const props = defineProps({
        switcher: Object,
        size: String,
        title: String,
    })

    const versionStore = useVersionStore()

    const { version, dataModeForTheme } = storeToRefs(versionStore)

    const modalUuid = ref(uuidv4())

    const active = computed(() => {
        return props.switcher?.users?.find((user) => user.active)
    })

    const openSwitcher = async () => {
        const modal = await modalController.create({
            cssClass: 'ds-modal-bottom-sheet',
            component: InlineSwitcherModal,
            componentProps: {
                active: active.value,
                users: props.switcher.users,
                title: props.title,
                onSelected: (user) => {
                    emit('switch', user)
                    modal.dismiss()
                },
                onCancelled: () => {
                    modal.dismiss()
                },
            },
            initialBreakpoint: 1,
            breakpoints: [0, 1],
        })

        await modal.present()
    }
</script>
